import { cn } from "@/utils";
import { t } from "i18next";
import { LucideAlertOctagon } from "lucide-react";
import { ButtonLink } from "../links";

export function ForbiddenState({
  resourceType,
  hideReturnHome,
  size = "md",
  className,
  hideIcon = false,
}: {
  resourceType?:
    | "trip"
    | "trips"
    | "trips.create"
    | "trips.edit"
    | "reservation"
    | "reservations"
    | "clients"
    | "client"
    | "employees"
    | "employee"
    | "role"
    | "roles"
    | "analytics"
    | "finance.ledger"
    | "finance"
    | "auditLog"
    | "payments"
    | "agency"
    | "discountCodes"
    | "discountCode"
    | "withdrawal"
    | "withdrawals";
  hideReturnHome?: boolean;
  size?: "sm" | "md";
  className?: string;
  hideIcon?: boolean;
}) {
  return (
    <div
      className={cn(
        "flex grow flex-col items-center justify-center rounded-lg text-center",
        size === "sm" ? "min-h-75 p-md" : "min-h-100 border border-dashed p-xl",
        className,
      )}
    >
      {!hideIcon ? (
        <div
          className={cn(
            "bg-orange-light mx-auto flex items-center justify-center rounded-full",
            size === "sm" ? "size-12" : "size-16",
          )}
        >
          <LucideAlertOctagon
            className={cn(
              "text-orange-filled",
              size === "sm" ? "size-6" : "size-8",
            )}
          />
        </div>
      ) : null}
      <h3
        className={cn(
          "text-orange-filled mt-1.5 font-semibold",
          size === "sm" ? "text-lg" : "text-xl",
        )}
      >
        {t("forbidden.title")}
      </h3>
      <p className={cn("text-text", size === "sm" ? "text-sm" : "text-base")}>
        {t(
          resourceType
            ? `${resourceType}.forbidden.description`
            : "forbidden.description.resource",
        )}
      </p>
      {!hideReturnHome ? (
        <ButtonLink to="/" className="mt-lg">
          {t("returnHome")}
        </ButtonLink>
      ) : null}
    </div>
  );
}
